"use client"

import styled from "@emotion/styled"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import { AppType, useAppType } from "contexts/AppTypeProvider"
import { AdvancedMarkerIconCharge, AdvancedMarkerIconSmall } from "ui"

const StyledMarker = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative; /* Ensure relative positioning for z-index to work */
  `

const StyledIconWrapper = styled.div`
  z-index: 999; /* Higher z-index for icon */
  position: absolute; /* Ensure icon is positioned above the text */
  top: -35px; /* Adjust the position as needed */
`

const StyledText = styled.div<{ active: boolean }>`
  min-width: 66px;
  height: 28px;
  border-radius: 20px;
  padding: 4px 20px;
  background-color: ${(props) =>
    props.active ? "black" : "rgba(255, 255, 255, 0.8)"};
  color: ${(props) => (props.active ? "white" : "black")};
  font-size: 14px;
  line-height: 20px;
  z-index: 1;
`

type Props = {
  lng: number
  lat: number
  fill?: string
  title: string
  active: boolean
  onClick: () => void
  showLabel: boolean
}

function StyledAdvancedMarker({
  lng,
  lat,
  fill,
  title,
  onClick,
  active,
  showLabel
}: Props) {
  const {appType} = useAppType()
  return (
    <AdvancedMarker
      zIndex={active ? 1000 : null}
      onClick={onClick}
      position={{ lng, lat }}
    >
      <StyledMarker>
        <StyledIconWrapper>
          { appType === AppType.Corporate ? <AdvancedMarkerIconSmall fill={fill} /> : <AdvancedMarkerIconCharge /> }
        </StyledIconWrapper>
        {showLabel && <StyledText active={active}>{title}</StyledText>}
      </StyledMarker>
    </AdvancedMarker>
  )
}

export default StyledAdvancedMarker
